import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition } from '@/models/configuratorx/configuratorSchema';
import { RoomGordionChairFamilyOptions,RoomGordionChairFamilyOption,RoomGordionBossTableOptions,RoomGordionBossTableOption } from '@/models/constants';
import PartsColor from '@/components/partsColor/PartsColor';
import Ori9bRoom from '@/components/families/ori/Ori9bRoom';


@Component({
  components: {
    Ori9bRoom,
    partsColor: PartsColor,
  },
})
export default class GordionRoom extends Vue {
  private _configuratorService: ConfiguratorService = undefined;
  @Inject()
  private _container: ComponentContainer;

  defHideObjects = [
    'ori',
    'm4',
    'gordion_tekil_masa_yyy',
    'gordion_kesonlu_masa_yyy',
  ];
  enableProducts = [];
  selectedProduct = null;
  chairFamilyList = RoomGordionChairFamilyOptions;
  bossTableList = RoomGordionBossTableOptions;
  selectedChairFamily = null;
  selectedBossTable = null;
  room = _.find(Store.roomState.roomConfiguratorConfig.products,x => x.id === 'gordion');

  async created() {
    Store.roomState.room = this.room;
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);

    this._configuratorService.hideObjects({
      objects:this.defHideObjects,
      operator: FilterOperators.Contains,
    });


    await this.applyDefault();





  }

  async applyDefault() {
    const  defSelection = this.room.default as GordionRoomSelection;
    this.selectedChairFamily = defSelection.chairFamily;
    this.selectedBossTable = defSelection.bossTable;
    this._configuratorService.showObjects({
      objects: [defSelection.chairFamily],
      operator: FilterOperators.Contains,
    });
    this._configuratorService.showObjects({
      objects: [defSelection.bossTable],
      operator: FilterOperators.Contains,
    });
  }

  async selectedBossTableChange() {
    await  this._configuratorService.hideObjects({
      objects: ['gordion_kesonlu_masa_yyy',
        'gordion_tekil_masa_yyy'],
      operator: FilterOperators.Contains,
    });
    await  this._configuratorService.showObjects({
      objects: [this.selectedBossTable],
      operator: FilterOperators.Contains,
    });

  }
  async selectedChairFamilyChange() {
    this._configuratorService.hideObjects({
      objects: ['ori','m4'],
      operator: FilterOperators.Contains,
    });
    this._configuratorService.showObjects({
      objects: [this.selectedChairFamily],
      operator: FilterOperators.Contains,
    });
    if (this.selectedChairFamily === 'ori') {
      this.enableProducts =  [
        {
          id: 'ori9b',
          name: 'ORI 9B',
          companentName: 'Ori9bRoom',
          defaults: {
            parts: [
              {
                id: 'backrest_hr',
                name: 'Backrest',
                palette: 'alkantra',
                color: 'Alkantra202',
              },
              {
                id: 'headrest_hr',
                name: 'Headrest',
                palette: 'alkantra',
                color: 'Alkantra202',
              },
              {
                id: 'seat_hr',
                name: 'Seat',
                palette: 'alkantra',
                color: 'Alkantra202',
              },
              {
                id: 'backplastic_hr',
                name: 'Backplastic',
                palette: 'alkantra',
                color: 'Alkantra202',
              },
            ],
          },
          partsPalettes: [
            {
              part: 'backrest_hr',
              materials: [
                'ori_9_baslik_arkakumas',
              ],
              colorPalettes: [
                'alkantra',
              ],
            },
            {
              part: 'headrest_hr',
              materials: [
                'ori_9_baslikkumas',
              ],
              colorPalettes: [
                'alkantra',
              ],
            },
            {
              part: 'seat_hr',
              materials: [
                'ori_9_baslik_altkumas',
              ],
              colorPalettes: [
                'alkantra',
              ],
            },
            {
              part: 'backplastic_hr',
              materials: [
                'ori_9_baslik_deri',

              ],
              colorPalettes: [
                'alkantra',
              ],
            },
          ],
          attributes: {
            title: 'ORI 9B',
            image: 'static/img/ori/ori9b.png',
          },
        },
        {
          id: 'ori9',
          name: 'ORI 9',
          companentName: 'Ori9bRoom',
          default: {
            parts: [
              {
                id: 'backrest_hr',
                name: 'Backrest',
                palette: 'alkantra',
                color: 'Alkantra202',
              },
              {
                id: 'headrest_hr',
                name: 'Headrest',
                palette: 'alkantra',
                color: 'Alkantra202',
              },
              {
                id: 'seat_hr',
                name: 'Seat',
                palette: 'alkantra',
                color: 'Alkantra202',
              },
              {
                id: 'backplastic_hr',
                name: 'Backplastic',
                palette: 'alkantra',
                color: 'Alkantra202',
              },
            ],
          },
          partsPalettes: [
            {
              part: 'backrest_hr',
              materials: [
                'ori_9_deri',
              ],
              colorPalettes: [
                'alkantra',
              ],
            },
            {
              part: 'headrest_hr',
              materials: [
                'ori_9_baslik',
              ],
              colorPalettes: [
                'alkantra',
              ],
            },
            {
              part: 'seat_hr',
              materials: [
                'ori_9_arkakumas',
              ],
              colorPalettes: [
                'alkantra',
              ],
            },
            {
              part: 'backplastic_hr',
              materials: [
                'ori_9_arkakumas',

              ],
              colorPalettes: [
                'alkantra',
              ],
            },
          ],
          attributes: {
            title: 'ORI 9B',
            image: 'static/img/ori/ori9b.png',
          },
        },
        {
          id: 'ori7',
          name: 'ORI 7',
          companentName: 'Ori9bRoom',
          defaults: {
            parts: [
              {
                id: 'backrest_hr',
                name: 'Backrest',
                palette: 'alkantra',
                color: 'Alkantra202',
              },
              {
                id: 'seat_hr',
                palette: 'alkantra',
                name: 'Seat',
                color: 'Alkantra202',
              },
              {
                id: 'backplastic_hr',
                palette: 'leather1',
                name: 'alkantra',
                color: 'Alkantra202',
              },
            ],
          },
          partsPalettes: [
            {
              part: 'backrest_hr',
              materials: [
                '1_ori7',
              ],
              colorPalettes: [
                'alkantra',
              ],
            },
            {
              part: 'seat_hr',
              materials: [
                'a_seatrest',
              ],
              colorPalettes: [
                'alkantra',
              ],
            },
            {
              part: 'backplastic_hr',
              materials: [
                '2_ori7',
                'b_seatrest',
              ],
              colorPalettes: [
                'alkantra',
              ],
            },
          ],
          attributes: {
            title: 'deniz',
            image: 'static/img/ori/ori7.png',
          },
        },
      ];
      this.selectedProduct = this.enableProducts[0];
    }   else {
      this.enableProducts = [];
      this.selectedProduct = null;
    }

  }

  productChanged(product: any) {
    this.selectedProduct = product;
  }

  mounted() {

  }
}
export interface GordionRoomSelection {
  chairFamily: RoomGordionChairFamilyOption;
  bossTable: any;
  bossChair: any;
  guessChair: any;

}



// WEBPACK FOOTER //
// ./src/components/rooms/GordionRoom.ts